import { BUTTON } from '../Buttons/classnames';

// Option classnames

export const BASE_BOX =
  'inline-flex flex-shrink-0 justify-between items-center w-full h-56 px-16';

export const OPTION_WRAPPER =
  'inline-flex flex-col h-full w-full overflow-auto';

export const OPTION = `${BUTTON} ${BASE_BOX} text-base-main bg-white hover:text-primary-main hover:bg-gray-lighter`;
export const OPTION_DARK = `${BUTTON} ${BASE_BOX} text-base-lighter bg-base-lighter-24 hover:text-white hover:bg-rgba-purple-lighter-56`;
